/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BankAccountsDto,
  CreateOrUpdateBankAccountRequest,
  DeleteBankAccountRequest,
  GetBankAccountsByPersonIdParams,
  GetBankAccountsPermissionTypeParams,
  PermissionType
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetBankAccountsPermissionTypeUrl = (params?: GetBankAccountsPermissionTypeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/BankAccounts/GetBankAccountsPermissionType?${stringifiedParams}` : `/api/BankAccounts/GetBankAccountsPermissionType`
}

export const getBankAccountsPermissionType = async (params?: GetBankAccountsPermissionTypeParams, options?: Parameters<typeof customInstance>[1]): Promise<PermissionType> => {

  return customInstance<PermissionType>(getGetBankAccountsPermissionTypeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBankAccountsPermissionTypeQueryKey = (params?: GetBankAccountsPermissionTypeParams,) => {
    return [
    `/api/BankAccounts/GetBankAccountsPermissionType`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBankAccountsPermissionTypeQueryOptions = <TData = Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError = ErrorType<unknown>>(params?: GetBankAccountsPermissionTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankAccountsPermissionTypeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankAccountsPermissionType>>> = ({ signal }) => getBankAccountsPermissionType(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBankAccountsPermissionTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getBankAccountsPermissionType>>>
export type GetBankAccountsPermissionTypeQueryError = ErrorType<unknown>


export function useGetBankAccountsPermissionType<TData = Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError = ErrorType<unknown>>(
 params: undefined |  GetBankAccountsPermissionTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankAccountsPermissionType>>,
          TError,
          Awaited<ReturnType<typeof getBankAccountsPermissionType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccountsPermissionType<TData = Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError = ErrorType<unknown>>(
 params?: GetBankAccountsPermissionTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankAccountsPermissionType>>,
          TError,
          Awaited<ReturnType<typeof getBankAccountsPermissionType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccountsPermissionType<TData = Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError = ErrorType<unknown>>(
 params?: GetBankAccountsPermissionTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBankAccountsPermissionType<TData = Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError = ErrorType<unknown>>(
 params?: GetBankAccountsPermissionTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBankAccountsPermissionTypeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetBankAccountsPermissionTypeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError = ErrorType<unknown>>(params?: GetBankAccountsPermissionTypeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankAccountsPermissionTypeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankAccountsPermissionType>>> = ({ signal }) => getBankAccountsPermissionType(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetBankAccountsPermissionTypeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBankAccountsPermissionType>>>
export type GetBankAccountsPermissionTypeSuspenseQueryError = ErrorType<unknown>


export function useGetBankAccountsPermissionTypeSuspense<TData = Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError = ErrorType<unknown>>(
 params: undefined |  GetBankAccountsPermissionTypeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccountsPermissionTypeSuspense<TData = Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError = ErrorType<unknown>>(
 params?: GetBankAccountsPermissionTypeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccountsPermissionTypeSuspense<TData = Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError = ErrorType<unknown>>(
 params?: GetBankAccountsPermissionTypeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBankAccountsPermissionTypeSuspense<TData = Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError = ErrorType<unknown>>(
 params?: GetBankAccountsPermissionTypeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBankAccountsPermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBankAccountsPermissionTypeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetBankAccountsByPersonIdUrl = (params?: GetBankAccountsByPersonIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/BankAccounts/GetBankAccountsByPersonId?${stringifiedParams}` : `/api/BankAccounts/GetBankAccountsByPersonId`
}

export const getBankAccountsByPersonId = async (params?: GetBankAccountsByPersonIdParams, options?: Parameters<typeof customInstance>[1]): Promise<BankAccountsDto> => {

  return customInstance<BankAccountsDto>(getGetBankAccountsByPersonIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBankAccountsByPersonIdQueryKey = (params?: GetBankAccountsByPersonIdParams,) => {
    return [
    `/api/BankAccounts/GetBankAccountsByPersonId`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBankAccountsByPersonIdQueryOptions = <TData = Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError = ErrorType<unknown>>(params?: GetBankAccountsByPersonIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankAccountsByPersonIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankAccountsByPersonId>>> = ({ signal }) => getBankAccountsByPersonId(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBankAccountsByPersonIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBankAccountsByPersonId>>>
export type GetBankAccountsByPersonIdQueryError = ErrorType<unknown>


export function useGetBankAccountsByPersonId<TData = Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetBankAccountsByPersonIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankAccountsByPersonId>>,
          TError,
          Awaited<ReturnType<typeof getBankAccountsByPersonId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccountsByPersonId<TData = Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError = ErrorType<unknown>>(
 params?: GetBankAccountsByPersonIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankAccountsByPersonId>>,
          TError,
          Awaited<ReturnType<typeof getBankAccountsByPersonId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccountsByPersonId<TData = Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError = ErrorType<unknown>>(
 params?: GetBankAccountsByPersonIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBankAccountsByPersonId<TData = Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError = ErrorType<unknown>>(
 params?: GetBankAccountsByPersonIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBankAccountsByPersonIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetBankAccountsByPersonIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError = ErrorType<unknown>>(params?: GetBankAccountsByPersonIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankAccountsByPersonIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankAccountsByPersonId>>> = ({ signal }) => getBankAccountsByPersonId(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetBankAccountsByPersonIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBankAccountsByPersonId>>>
export type GetBankAccountsByPersonIdSuspenseQueryError = ErrorType<unknown>


export function useGetBankAccountsByPersonIdSuspense<TData = Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetBankAccountsByPersonIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccountsByPersonIdSuspense<TData = Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError = ErrorType<unknown>>(
 params?: GetBankAccountsByPersonIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccountsByPersonIdSuspense<TData = Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError = ErrorType<unknown>>(
 params?: GetBankAccountsByPersonIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBankAccountsByPersonIdSuspense<TData = Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError = ErrorType<unknown>>(
 params?: GetBankAccountsByPersonIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByPersonId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBankAccountsByPersonIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateOrUpdateBankAccountUrl = () => {




  return `/api/BankAccounts/CreateOrUpdateBankAccount`
}

export const createOrUpdateBankAccount = async (createOrUpdateBankAccountRequest?: CreateOrUpdateBankAccountRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getCreateOrUpdateBankAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOrUpdateBankAccountRequest)
  }
);}





export const getCreateOrUpdateBankAccountMutationKey = () => ['createOrUpdateBankAccount'] as const;

export const getCreateOrUpdateBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrUpdateBankAccount>>, TError,CreateOrUpdateBankAccountMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrUpdateBankAccount>>, TError,CreateOrUpdateBankAccountMutationVariables, TContext> => {

const mutationKey = getCreateOrUpdateBankAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrUpdateBankAccount>>, CreateOrUpdateBankAccountMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createOrUpdateBankAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrUpdateBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createOrUpdateBankAccount>>>
    export type CreateOrUpdateBankAccountMutationBody = BodyType<CreateOrUpdateBankAccountRequest> | undefined
    export type CreateOrUpdateBankAccountMutationError = ErrorType<unknown>
    export type CreateOrUpdateBankAccountMutationVariables = {data?: BodyType<CreateOrUpdateBankAccountRequest>}

    export const useCreateOrUpdateBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrUpdateBankAccount>>, TError,CreateOrUpdateBankAccountMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrUpdateBankAccount>>,
        TError,
        CreateOrUpdateBankAccountMutationVariables,
        TContext
      > => {
      return useMutation(getCreateOrUpdateBankAccountMutationOptions(options), queryClient);
    }
    export const getDeleteBankAccountUrl = () => {




  return `/api/BankAccounts/DeleteBankAccount`
}

export const deleteBankAccount = async (deleteBankAccountRequest?: DeleteBankAccountRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getDeleteBankAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteBankAccountRequest)
  }
);}





export const getDeleteBankAccountMutationKey = () => ['deleteBankAccount'] as const;

export const getDeleteBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBankAccount>>, TError,DeleteBankAccountMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBankAccount>>, TError,DeleteBankAccountMutationVariables, TContext> => {

const mutationKey = getDeleteBankAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBankAccount>>, DeleteBankAccountMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deleteBankAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBankAccount>>>
    export type DeleteBankAccountMutationBody = BodyType<DeleteBankAccountRequest> | undefined
    export type DeleteBankAccountMutationError = ErrorType<unknown>
    export type DeleteBankAccountMutationVariables = {data?: BodyType<DeleteBankAccountRequest>}

    export const useDeleteBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBankAccount>>, TError,DeleteBankAccountMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBankAccount>>,
        TError,
        DeleteBankAccountMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteBankAccountMutationOptions(options), queryClient);
    }
